import { Component, Input } from '@angular/core';
import { DropdownOptions } from '@shared/models/dropdown-options.interface';
import { SpControlBaseDirective } from '@shared/directives/sp-control-base/sp-control-base.directive';

@Component({
  selector: 'sp-dropdown-input',
  templateUrl: './dropdown-input.component.html',
  styleUrls: ['../input/style.scss', './dropdown-input.component.scss'],
})
export class DropdownInputComponent extends SpControlBaseDirective {
  @Input() options: DropdownOptions[] = [];

  updateValidation() {
    this.errorMessage = this.formControl.dirty
      ? Object.entries(this.formControl.errors ?? {})
          .map(([validation, param]) => {
            switch (validation) {
              case 'required':
                return `${this.inputLabel} cannot be empty`;
              default:
                return param;
            }
          })
          .shift()
      : '';
  }
}
